import React from "react";

interface MetricSkeletonProps {
  accent?: "green" | "red" | "orange" | "default";
}

export const MetricSkeleton = ({ accent = "default" }: MetricSkeletonProps) => {
  // Map identical border accents to prevent structural shifting during layout pop-in
  const borderStyles = {
    green: "border-l-emerald-500",
    red: "border-l-rose-500",
    orange: "border-l-[var(--actionOrange)]",
    default: "border-l-[var(--primary)]",
  }[accent];

  return (
    <div
      className={`w-full min-h-[96px] bg-white border border-y-slate-200 border-r-slate-200 border-l-4 ${borderStyles} rounded-2xl p-4 flex items-center justify-between shadow-xs relative overflow-hidden`}
    >
      {/* Skeleton Content Metrics */}
      <div className="space-y-2.5 min-w-0 flex-1">
        {/* Label Placeholder */}
        <div className="h-3 w-24 rounded bg-slate-200/80 animate-pulse" />
        
        {/* Value Numeric Group Placeholder */}
        <div className="flex items-baseline gap-1.5">
          <div className="h-8 w-16 rounded-md bg-slate-200/50 animate-pulse" />
          <div className="h-2 w-7 rounded bg-slate-100 animate-pulse" />
        </div>
      </div>

      {/* Action/Icon Panel Placeholder */}
      <div className="p-1 flex items-center justify-center shrink-0">
        <div className="w-10 h-10 rounded-xl bg-slate-200/60 border border-slate-200/30 animate-pulse" />
      </div>
    </div>
  );
};